module.exports = __webpack_public_path__ + "img/vape-shop-custom-website.96e73980.jpeg";